/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BCMBookingIdRemarkRuleListConfiguration,
    BCMBookingIdRemarkRuleListConfigurationFromJSON,
    BCMBookingIdRemarkRuleListConfigurationToJSON,
    BCMBookingIdRemarkRuleListItem,
    BCMBookingIdRemarkRuleListItemFromJSON,
    BCMBookingIdRemarkRuleListItemToJSON,
    BCMBookingIdRemarkRuleListQuery,
    BCMBookingIdRemarkRuleListQueryFromJSON,
    BCMBookingIdRemarkRuleListQueryToJSON,
} from '../models';

export interface ApiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleListDataPostRequest {
    bCMBookingIdRemarkRuleListQuery?: BCMBookingIdRemarkRuleListQuery;
}

export interface ApiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleListDeleteDeleteRequest {
    id?: string;
}

/**
 * no description
 */
export class BCMBookingIdRemarkRuleListApi extends runtime.BaseAPI {

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleListConfigurationGetRaw(): Promise<runtime.ApiResponse<BCMBookingIdRemarkRuleListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/BookingIdRemark/BCMBookingIdRemarkRuleList/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BCMBookingIdRemarkRuleListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleListConfigurationGet(): Promise<BCMBookingIdRemarkRuleListConfiguration> {
        const response = await this.apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleListDataPostRaw(requestParameters: ApiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleListDataPostRequest): Promise<runtime.ApiResponse<Array<BCMBookingIdRemarkRuleListItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/BookingIdRemark/BCMBookingIdRemarkRuleList/Data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BCMBookingIdRemarkRuleListQueryToJSON(requestParameters.bCMBookingIdRemarkRuleListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BCMBookingIdRemarkRuleListItemFromJSON));
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleListDataPost(requestParameters: ApiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleListDataPostRequest): Promise<Array<BCMBookingIdRemarkRuleListItem>> {
        const response = await this.apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleListDataPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleListDeleteDeleteRaw(requestParameters: ApiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleListDeleteDeleteRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/BookingIdRemark/BCMBookingIdRemarkRuleList/Delete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleListDeleteDelete(requestParameters: ApiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleListDeleteDeleteRequest): Promise<void> {
        await this.apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleListDeleteDeleteRaw(requestParameters);
    }

}
